import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function typography() {
  return (
    <section className="typography p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <h2>Typography and Colors</h2>

            <div className="font_img d-none d-md-block">
              <StaticImage
                src="../../../images/case-studies/teemates/font_family.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={187}
                height={198}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto text-center"
          >
            <div className="typo_right_img d-none d-md-block">
              <StaticImage
                src="../../../images/case-studies/teemates/typography_1.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={622}
                height={351}
              />
            </div>
            <div className="typo_mob d-sm-block d-md-none">
              <StaticImage
                src="../../../images/case-studies/teemates/typography_mob.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={750}
                height={3003}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <div className="box_typo_img d-none d-md-block">
              <StaticImage
                src="../../../images/case-studies/teemates/typo_box.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1686}
                height={399}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default typography;
